import React, { FC } from 'react';
import Recaptcha from 'react-google-recaptcha';

import { ENV_RECAPTCHA_SITE_KEY } from '@lib/core/service/consts';

interface IReCaptchaContainer {
  setIsBtnDisabled: (args: boolean) => void;
  isShowRecaptcha: boolean;
  recaptchaRef: React.RefObject<Recaptcha>;
  handleValue: (recaptchaValue: string) => void;
}

export const ReCaptchaContainer: FC<IReCaptchaContainer> = ({
  recaptchaRef,
  setIsBtnDisabled,
  isShowRecaptcha,
  handleValue,
}) => {
  const asyncScriptOnLoad = () => {
    setIsBtnDisabled(false);
  };

  return isShowRecaptcha ? (
    <Recaptcha
      ref={recaptchaRef}
      asyncScriptOnLoad={asyncScriptOnLoad}
      sitekey={ENV_RECAPTCHA_SITE_KEY}
      size="invisible"
      onChange={handleValue}
    />
  ) : null;
};
